<template>
    <b-modal
        :visible="true"
        size="lg"
        title="평가 프로파일 비교 실행"
        @hidden="$emit('close')"
    >
        <p class="text-muted">
            같은 문항에 대해 두 프로파일(또는 기본 vs 다른 평가자 기준)로 AI 평가를 실행해
            결과를 비교합니다. 평가는 비동기로 처리되며, 결과는 평가 관리 화면에서 확인합니다.
        </p>

        <b-form>
            <b-row>
                <b-col md="4">
                    <b-form-group label="캠페인 ID">
                        <b-form-input v-model.number="campaignId" type="number" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="기업 ID">
                        <b-form-input v-model.number="companyId" type="number" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="문항 코드 (선택)">
                        <b-form-input v-model="subCode" placeholder="비우면 전체 문항 대상" />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-card no-body class="p-3 mb-3">
                <b-row>
                    <b-col md="6">
                        <b-form-group label="프로파일 A (기본/기준)">
                            <b-form-input :value="baseProfile.profile_name" readonly />
                            <small class="text-muted">id: {{ baseProfile.id }} · {{ baseProfile.status }}</small>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="프로파일 B (비교 대상)">
                            <b-form-select v-model="compareProfileId" :options="otherProfileOptions" />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-card>
        </b-form>

        <b-alert :show="!!message" :variant="messageVariant">{{ message }}</b-alert>

        <template #modal-footer>
            <b-button variant="secondary" @click="$emit('close')">닫기</b-button>
            <b-button
                variant="primary"
                :disabled="running || !canRun"
                @click="runCompare"
            >
                <b-spinner v-if="running" small /> 비교 실행
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import { getErrorMessage } from '@core/utils/api/errorMessage';
export default {
    name: 'EvalProfileCompare',
    props: {
        baseProfile: { type: Object, required: true },
        profiles: { type: Array, default: () => [] },
    },
    data() {
        return {
            campaignId: null,
            companyId: null,
            subCode: '',
            compareProfileId: null,
            running: false,
            message: '',
            messageVariant: 'info',
        };
    },
    computed: {
        otherProfileOptions() {
            return [
                { value: null, text: '선택...' },
                ...this.profiles
                    .filter((p) => p.id !== this.baseProfile.id)
                    .map((p) => ({
                        value: p.id,
                        text: `${p.profile_name} (${p.status})`,
                    })),
            ];
        },
        canRun() {
            return this.campaignId && this.companyId && this.compareProfileId;
        },
    },
    methods: {
        async runCompare() {
            this.running = true;
            this.message = '';
            try {
                const basePayload = {
                    campaign_id: this.campaignId,
                    company_id: this.companyId,
                    sub_code: this.subCode || undefined,
                    profile_id: this.baseProfile.id,
                };
                const comparePayload = { ...basePayload, profile_id: this.compareProfileId };

                // 두 프로파일로 각각 평가 실행 (비동기 큐 적재)
                await this.$axios.post('/assessments/ai-audit', basePayload);
                await this.$axios.post('/assessments/ai-audit', comparePayload);

                this.messageVariant = 'success';
                this.message = '두 프로파일로 평가를 요청했습니다. '
                    + '결과는 AI 평가 관리 화면에서 프로파일별로 확인할 수 있습니다.';
            } catch (e) {
                this.messageVariant = 'danger';
                const msg = getErrorMessage(e, '평가 실행 요청에 실패했습니다.');
                this.message = msg;
            } finally {
                this.running = false;
            }
        },
    },
};
</script>
